/// <reference path="../test-assignment/test-assignment.component.ts" />
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import * as ngswal from "sweetalert";
import { FreelancerlistAPIModel } from './freelancerlistmodel';
import { Router } from '@angular/router';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import { TestAssignmentComponent } from '../test-assignment/test-assignment.component';
import { TestAssessmentComponent } from '../test-assessment/test-assessment.component';

declare var $;

@Component({
  selector: 'app-freelancerlist',
  templateUrl: './freelancerlist.component.html',
  styleUrls: ['./freelancerlist.component.css']
})
/** freelancerlist component*/
export class FreelancerlistComponent implements OnInit {
  modelItem = new FreelancerlistAPIModel();
  static modelItemSt = new FreelancerlistAPIModel();
  dataTable: any;
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;

  dataTableRP: any;
  @ViewChild('dataTableRP', { static: false }) tableRP;
  dataSetRP: any;

  dataTableAssign: any;
  @ViewChild('dataTableAssign', { static: false }) tableAssign;
  dataSetAssign: any;

  static dataTableAssign: any;
  @ViewChild('dataTableAssign', { static: false }) static tableAssign;
  static dataSetAssign: any;

  fileBase64: any;
  file: any;
  tg: any;
  vendorname: any;
  public CountryList: any;
  public CityList: any;
  CityIDPop: any;
  public StateList: any;
  StateIDPop: any;
  public interestList: any;
  public restrictionList: any;
  public sourceList: any;
  public languageList: any;
  statuses: boolean = false;
  Freelancerid: any;
  Description: any;
  DownloadFilepath: any;
  VendorEmail: any;
  Category: any;
  ArticleNo: any;
  VendorName: any;
  EmailID: any;
  ArticleID: any;
  CategoryList: any;
  TestCategoryList: any;
  FreelancerCT = ''; AssignmentPendingCT = ''; AssReturnPendingCT = ''; AssessmentPendingCT = ''; SelectedCT = ''; RejectCT = '';
  MicrosoftTeamId: any;
  AlternateEmailID: any;
  ContactNo: any;
  DOB: any;
  Address: any;
  Gender: any;
  ZIPPostCode: any;
  Country: any;
  StateProvince: any;
  City: any;
  Source: any;
  Languages: any;
  Restriction: any;
  Interest: any;
  Notes: any;
  Response: string;
  categoryList: any;
  articleList: any;
  showpopupTestassign: boolean;
  AssignmentPending: any;
  FreelancerList: any;
  AssignReturnPending: any;
  AssesmentPending: any;
  Selected: any;
  Reject: any;
  dataSetSummary: string;
  dataTableSummary: any;
  tableAssignsumary: any;
  showpopupTestassessment: boolean;
  static testAssignFrom: string;
  inviteEmailID: string;
  showModal: boolean = false;
  freelancerApproveStatus: string = "";

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  /** freelancerlist ctor */
  constructor(private router: Router, http: HttpClient, private renderer: Renderer2) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <FreelancerlistAPIModel>data["FreelancerlistPage"];
        FreelancerlistComponent.modelItemSt = <FreelancerlistAPIModel>data["FreelancerlistPage"];

        this.GetFreelancerData();
        this.GetFreelancerReports();
        this.loadGeneralmethod();
        this.GetFreelancerAssignmentPending();
        //$('#ULTabul').hide();
        this.GetDashboardSummary();
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
          $($.fn.dataTable.tables(true)).DataTable()
            .columns.adjust();
        });
        $('#ddlSourceList').select2({
          placeholder: "Select Source",
          allowClear: true, tags: true,

        });
        $('#ddlSourceList').val([]).trigger('change');

        $('#ddlLanguageList').select2({
          placeholder: "Select Language",
          allowClear: true, tags: true,

        });
        $('#ddlLanguageList').val([]).trigger('change');

        $('#ddlInterestList').select2({
          placeholder: "Select interest",
          allowClear: true, tags: true,

        });
        $('#ddlInterestList').val([]).trigger('change');

        $('#ddlRestrictionList').select2({
          placeholder: "Select Restriction",
          allowClear: true, tags: true,

        });
        $('#ddlRestrictionList').val([]).trigger('change');

        $('#ddlCountry').select2({
          placeholder: "Select Country",
          allowClear: true, tags: true,

        });
        $('#ddlCountry').val([]).trigger('change');


        $('#ddlState').select2({
          placeholder: "Select Sate",
          allowClear: true, tags: true,

        });
        $('#ddlState').val([]).trigger('change');

        $('#ddlCity').select2({
          placeholder: "Select City",
          allowClear: true, tags: true,

        });
        $('#ddlCity').val([]).trigger('change');

        $('#ddlCategory').select2({
          placeholder: "Select Category",
          allowClear: true, tags: true,

        });
        $('#ddlCategory').val([]).trigger('change');
        $('#ddlFreelancerCat').select2({
          placeholder: "Select Category",
          dropdownParent: "#divMainFilter"
          // allowClear: true, tags: true,

        });
        $('#ddlFreelancerCat').val([]).trigger('change');
        $('#ddlTestCategory').select2({
          placeholder: "Select Category",
          dropdownParent: "#divTestassigntab"
          //allowClear: true, tags: true,

        });
        $('#ddlTestCategory').val([]).trigger('change');
        //this.GetArticleList();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  loadGeneralmethod() {
    $('#Txt_Checklist').css('height', GlobalConstants.size.height - 560);
  }

  //Get All Countries list
  GetCountryList(): void {
    ApiMethod.getMethod(this.modelItem.CountryListAPI).subscribe(
      result => {
        this.CountryList = result.aCountryList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get State by Country
  GetState(StateID = 0, CityID = 0): void {
    ApiMethod.getMethod(this.modelItem.StateListAPI + $('#ddlCountry').val()).subscribe(
      result => {

        this.StateList = result.aStateList;
        this.StateIDPop = StateID;
        if (CityID > 0)
          this.GetCity(StateID, CityID);
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get City by State
  GetCity(StateID = 0, CityID = 0): void {
    let nstateId = $('#ddlState').val();
    if (nstateId == null) {
      nstateId = StateID;
    }

    ApiMethod.getMethod(this.modelItem.CityListAPI + nstateId).subscribe(
      result => {
        this.CityList = result.aCityList;
        this.CityIDPop = CityID;
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get All source list
  GetSourceList(): void {
    ApiMethod.getMethod(this.modelItem.SourceListAPI).subscribe(
      result => {
        this.sourceList = result.aSourceList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Language list
  GetLanguageList(): void {
    ApiMethod.getMethod(this.modelItem.LanguageListAPI).subscribe(
      result => {
        this.languageList = result.aLanguageList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Interest list
  GetInterestList(): void {
    ApiMethod.getMethod(this.modelItem.InterestListAPI).subscribe(
      result => {
        this.interestList = result.aInterestList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All restriction list
  GetRestrictionList(): void {
    ApiMethod.getMethod(this.modelItem.InterestListAPI).subscribe(
      result => {
        this.restrictionList = result.aInterestList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });

  }

  //Get All Category List

  GetCategoryList(): void {
    ApiMethod.getMethod(this.modelItem.CategoryListAPI).subscribe(
      result => {
        this.CategoryList = result.aCategoryList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  //Get All ArticleNo list
  //GetArticleList(): void {
  //  ApiMethod.getMethod(this.modelItem.ArticleListAPI).subscribe(
  //    result => {
  //      this.articleList = result.aArticleList;
  //    }, error => {
  //      $("#LoadingImage").hide();
  //      ngswal("Warning !", error, "warning");
  //    });
  //}
  //GetArticleTitleList() {
  //  var artid = $("#ddlArticle").val();
  //  if (artid == null || artid == 0 || artid == "") {
  //    return false;
  //  }
  //  ApiMethod.getMethod(this.modelItem.ArticleTitleAPI + artid).subscribe(
  //    result => {
  //      var aitem = result.aArticleList;
  //      $("#Txt_articleTitle").val(aitem[0].ArticleTitle);
  //    }, error => {
  //      $("#LoadingImage").hide();

  //    });
  //}
  //EmailID validation
  emailIdOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = "";
      return ngswal("Warning !", "email not valid", "warning");
    }
    return true;
  }
  //phone number validation
  numbervalidate(event): boolean {
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(event.currentTarget.value)) {
      event.currentTarget.value = "";
      return ngswal("Warning !", "Number not valid", "warning");
    }
    return true;
  }

  // check duplication email
  onSearchChange(event): void {
    this.checkEmail(event.currentTarget.value);
  }

  checkEmail(searchValue) {
    $("#LoadingImage").show();

    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(searchValue)) {
      searchValue = "";
      $("#LoadingImage").hide();
      return ngswal("Warning !", "email not valid", "warning");
    }
    var EmailID;

    if (searchValue == "")
      EmailID = $("#Txt_EmailID").val()
    else
      EmailID = searchValue;


    var FreelancerData = {
      EmailID: EmailID,
    };

    ApiMethod.postMethod(this.modelItem.CheckDuplicateAPI, FreelancerData).subscribe(
      response => {
        $("#LoadingImage").hide();

        if (response.status == "duplicate") {
          this.statuses = true;
          $("#txtTitle").val("");
          $("#txtFreelancerEmail").val("");
          ngswal("Failed !", response.message, "error");
          /*return this.status;*/
        }
        else {
          this.statuses = false;
          /*  return this.status;*/
        }
      }, error => {
        $("#LoadingImage").hide();

        ngswal("Failed !", error.error.Message, "error");
      });

  }


  onerrorImageLoad() {
    var zActHostpath = document.location.pathname.split('/')[1];
    $('#imgProfile').attr('src', '/' + zActHostpath + "../../../assets/Images/userLogo.jpg");
  }
  // showPreview Image Upload
  showPreview(event) {
    var ext = $('#imageUploadForm').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');

      ngswal("Failed !", "Invalid Image format", "warning");
      return false;
    }
    else if (event.target.files[0].size > 2000000) {
      $('#imageUploadForm').val("");
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
      ngswal("Failed !", "Please upload photo less than 2MB", "warning");
      return false;
    }

    if (event.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        $('#imgProfile').attr('src', fileReader.result);
      }
      fileReader.readAsDataURL(event.target.files[0]);
    }
  }
  //resume fileupload
  onFileSelected(fileInput: any) {

    var ext = $('#doc_file').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
      $('#doc_file').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 50000) {
      $('#doc_file').val("");
      ngswal("Failed !", "Please upload File less than 50KB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;

          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }
  //DOB validation
  Dobdatevalidation(event) {
    var x = new Date($("#Txt_DOB").val());
    var Cnow = new Date();
    if ($("#Txt_DOB").val() == "") {
      $("#Txt_DOB").focus();
    }
    else if (Cnow.getFullYear() - x.getFullYear() < 18) {
      ngswal("Failed !", "DOB Not Valid", "warning");
      /*$("#Txt_DOB").val('');*/
    }
  }

  //Ratings Validation

  validateForm() {
    var rating = new rating($("Txt_Ratings").val());
    if (rating < 0 || rating > 5) {
      alert("Rating must be between 0 and 5.");
    }
    return false;
  }

  //Freelancer data

  GetFreelancerData() {
    $("#LoadingImage").show();

    var Freelancerdata = {
      LoginID: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };
    ApiMethod.postMethod(FreelancerlistComponent.modelItemSt.FreelancerdataAPI, Freelancerdata).subscribe(
      Response => {
        this.dataSet = JSON.stringify(Response.aFreelancerdata); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.gridColumnList; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;

        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 280);
        dataItem.modulename = 'FreelancerModule';
        //dataItem.aNewButtonName = 'BtnPopup';
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.aNewButtonToolTip = 'Invite';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  showInvite() {
    $("#modalPopupInvite").show();
    //  $('#divFreelancerInvite').css({ 'height': (GlobalConstants.size.height - 240), 'resize': 'none' });
    $("#tblAddFreelancerInvite tbody").html('');
    $('#txtFreelancerFirstName').val('');
    $('#txtFreelancerMiddleName').val('');
    $('#txtFreelancerLastName').val('');
    $('#txtFreelancerEmail').val('');
    $("#ddlFreelancerCat").val(-1).change();
    $('#Txt_MailBody').jqte();
    this.inviteEmailID = "";
    this.GetCategoryList();
    ApiMethod.getMethod(this.modelItem.GetInviteEmailTemplateAPI).subscribe(
      result => {

        $('#modalPopupInvite #divMailInvite .jqte_editor').html(result.aTemplate[0].MailBody);
        $('#txtFromInvite').val(result.aTemplate[0].FromEmailId);
        $('#txtToInvite').val(result.aTemplate[0].NotifyToEmail);
        $('#txtCCInvite').val(result.aTemplate[0].NotifyCcEmail);
        $('#txtBCCInvite').val(result.aTemplate[0].NotifyBccEmail);
        $('#txtSubjectInvite').val(result.aTemplate[0].MailSubject);
      }, error => {

        ngswal("Warning !", error, "warning");
      });
    $('#divMailInvite .jqte_editor').css({ 'height': (GlobalConstants.size.height - 450), 'resize': 'none' });
  }
  SendInvite() {
    var getInviteFreelancerList = [];
    getInviteFreelancerList = GlobalConstants.GetTableRowToList('tblAddFreelancerInvite', 'Category List', false);
    for (var i = 0; i < getInviteFreelancerList.length; i++) {
      getInviteFreelancerList[i] = getInviteFreelancerList[i].toString();
    }

    $("#LoadingImagePopup").show();
    var dataItem = {
      InviteFreelancerList: getInviteFreelancerList,
      From: $('#txtFromInvite').val(),
      To: $('#txtToInvite').val(),
      CC: $('#txtCCInvite').val(),
      Bcc: $('#txtBCCInvite').val(),
      Subject: $('#txtSubjectInvite').val(),
      MailBody: $("#Txt_MailBody").val().trim(),
      LoginId: localStorage.aLoginID
    };
    ApiMethod.postMethod(this.modelItem.SendFreelancerInviteAPI, dataItem).subscribe(
      resonse => {

        $("#LoadingImagePopup").hide();
        if (resonse.Status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Sent!",
            text: "Invitation sent successfully!",
            showConfirmButton: true,
            timer: 1500
          });
          this.hide();
        }
        else {
          ngswal("Failed !", resonse.Message, "warning");
          $("#LoadingImagePopup").hide();
        }


      },
      error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImagePopup").hide();

      }
    );

  }
  AddInviteFreelancer() {

    var selText = '';
    $("#ddlFreelancerCat option:selected").each(function () {
      var $this = $(this);
      if ($this.length) {
        selText = selText + $this.text() + ', ';
      }
    });
    if ($('#txtFreelancerFirstName').val() == "") {
      $('#txtFreelancerFirstName').val("");
      ngswal("Failed !", "Please Enter First Name..!", "warning");
      return;
    }
    if ($('#txtFreelancerEmail').val() == "") {
      $('#txtFreelancerEmail').val("");
      ngswal("Failed !", "Please Enter Email..!", "warning");
      return;
    }
    if (selText == "") {
      $('#ddlFreelancerCat').val("");
      ngswal("Failed !", "Please Select Category..!", "warning");
      return;
    }
    if (this.inviteEmailID.indexOf($('#txtFreelancerEmail').val().trim()) != -1) {
      $('#txtFreelancerEmail').val("");
      ngswal("Failed !", "Email already added..!", "warning");
      return;
    }
    var FreelancerData = {
      EmailID: $('#txtFreelancerEmail').val(),
    };

    var rowCount = $('#tblAddFreelancerInvite tr').length;
    var nRowL = "";

    nRowL += "<tr>";
    nRowL += "<td class='rowNo'>" + (rowCount).toString() + "</td>";
    nRowL += "<td class='FirstNameFreelancer'> " + $('#txtFreelancerFirstName').val() + "</td>";
    nRowL += "<td class='MiddleNameFreelancer'> " + $('#txtFreelancerMiddleName').val() + "</td>";
    nRowL += "<td class='LastNameFreelancer'> " + $('#txtFreelancerLastName').val() + "</td>";
    nRowL += "<td class='EmailIDFreelancer'>" + $('#txtFreelancerEmail').val() + "</td>";
    nRowL += "<td class='CategoryFreelancer'> " + selText + "</td>";
    nRowL += "<td style='display:none;'>" + $("#ddlFreelancerCat").val().toString().replace(',', '|') + "</td>";
    nRowL += "<td style='text-align:center;'><i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;text-align:center;' onclick=localStorage.aDeleteID='" + $('#txtFreelancerEmail').val() + "';$('#btnDeleteInviteFreelancer').trigger('click');></i></td>";
    nRowL += "</tr>";

    this.inviteEmailID = this.inviteEmailID + $('#txtFreelancerEmail').val().trim();
    $("#tblAddFreelancerInvite tbody").append(nRowL);
    $('#txtFreelancerFirstName').val('');
    $('#txtFreelancerMiddleName').val('');
    $('#txtFreelancerLastName').val('');
    $('#txtFreelancerEmail').val('');
    $("#ddlFreelancerCat").val(-1).change();

  }
  DeleteInviteFreelancer() {
    ngswal({
      title: "Are you confirm to delete?",
      text: "Freelancer deleted Permanently..!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnDeleteInviteFreelancerConfirmation').trigger("click");
        } else {
          return false;
        }
      });
  }
  DeleteInviteFreelancerConfirmation() {

    $('#tblAddFreelancerInvite tr').each(function () {

      if ($(this).find(".EmailIDFreelancer").html().toString().trim() == localStorage.aDeleteID.toString().trim()) {

        $(this).closest("tr").remove();
      }

    });
    let i = 0;
    $('#tblAddFreelancerInvite tr').each(function () {
      $(this).find(".rowNo").html(i);
      i = i + 1;

    });
    this.inviteEmailID = this.inviteEmailID.toString().replace(localStorage.aDeleteID.toString().trim(), "");
  }
  showInvitePreview() {
    //if ($('#InviteTabul a.nav-link.active').text() == "Preview") {
    //  alert('yest');
    if ($('#tblAddFreelancerInvite').find("tbody>tr").first().length == 0) {
      ngswal("Failed !", "Please enter freelancer details..!", "warning");
      //$("#InviteTabul li a").eq(2).removeClass("active");
      //$("#divPreviewInvite").removeClass("active");
      //$("#InviteTabul li a").eq(0).toggleClass("active");
      //$("#divFreelancerInvite").toggleClass("active");

      return;
    }

    let emailID = $('#tblAddFreelancerInvite').find("tbody>tr").first().find(".EmailIDFreelancer").html();
    let firstName = $('#tblAddFreelancerInvite').find("tbody>tr").first().find(".FirstNameFreelancer").html();
    let middleName = $('#tblAddFreelancerInvite').find("tbody>tr").first().find(".MiddleNameFreelancer").html();
    let lastName = $('#tblAddFreelancerInvite').find("tbody>tr").first().find(".LastNameFreelancer").html();
    let categoryName = $('#tblAddFreelancerInvite').find("tbody>tr").first().find(".CategoryFreelancer").html();

    $('#txtFromInvitePreview').val($('#txtFromInvite').val().toString().toLowerCase().replace('{vendoremail}', emailID).replace('{vendorname}', firstName + ' ' + lastName));
    $('#txtToInvitePreview').val($('#txtToInvite').val().toString().toLowerCase().replace('{vendoremail}', emailID).replace('{vendorname}', firstName + ' ' + lastName));
    $('#txtCCInvitePreview').val($('#txtCCInvite').val().toString().toLowerCase().replace('{vendoremail}', emailID).replace('{vendorname}', firstName + ' ' + lastName));
    $('#txtBCCInvitePreview').val($('#txtBCCInvite').val().toString().toLowerCase().replace('{vendoremail}', emailID).replace('{vendorname}', firstName + ' ' + lastName));
    $('#txtSubjectInvitePreview').val($('#txtSubjectInvite').val().toString().toLowerCase().replace('{vendoremail}', emailID).replace('{vendorname}', firstName + ' ' + lastName));



    $('#divPreviewData').html($('#Txt_MailBody').val().toString().toLowerCase().replace('{vendoremail}', emailID).replace('{vendorname}', firstName + ' ' + lastName));
    //}
  }
  GetFreelancerReports() {
    $("#LoadingImage").show();

    var FreelancerReports = {
      LoginID: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.GetFreelancerReportsAPI, FreelancerReports).subscribe(
      Response => {
        this.dataSetRP = JSON.stringify(Response.aFreelancerReports);// Data List
        this.dataSetRP = JSON.parse(this.dataSetRP);
        this.dataTableRP = $(this.tableRP.nativeElement);
        //Dynamic datable
        let aColList = Response.agridColumnReports; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTableRP;
        dataItem.dataset = this.dataSetRP;
        dataItem.dtheight = (GlobalConstants.size.height - 280);
        dataItem.modulename = 'FreelancerReport';
        dataItem.aNewButtonName = 'BtnAdd';
        dataItem.isDefault = false;
        this.dataTableRP = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
        
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  GetFreelancerAssignmentPending() {
    $("#LoadingImage").show();
    var FreelancerReports = {
      LoginID: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.GetFreelancerAssignmentPending, FreelancerReports).subscribe(
      Response => {
        this.dataSetAssign = JSON.stringify(Response.aAssignmentPending);// Data List
        //this.AssignmentPending = Response.aAssignmentPending.length;
        this.dataSetAssign = JSON.parse(this.dataSetAssign);
        this.dataTableAssign = $(this.tableAssign.nativeElement);
        //Dynamic datable
        let aColList = Response.aGridColumnPending; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTableAssign;
        dataItem.dataset = this.dataSetAssign;
        dataItem.dtheight = (GlobalConstants.size.height - 280);
        dataItem.modulename = 'FreelancerAssignment';
        dataItem.aNewButtonName = 'BtnAssignment';
        dataItem.isDefault = false;
        this.dataTableAssign = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
        
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  GetDashboardSummary() {
    $("#LoadingImage").show();
    var DashboardSummaryReport = {
      PublisherId: localStorage.aPubID
    };

    ApiMethod.getMethod(this.modelItem.GetFreelancerDashboardSummary + localStorage.aPubID).subscribe(
      Response => {
        this.dataSetSummary = JSON.stringify(Response.astatusDetails);
        var aitem = Response.astatusDetails;
        console.log(aitem);
        this.FreelancerList = (aitem.find(item => item.Category === "freelancerlist") || { Count: 0 }).Count;
        this.AssignmentPending = (aitem.find(item => item.Category === "AssignPending") || { Count: 0 }).Count;
        this.AssignReturnPending = (aitem.find(item => item.Category === "AssinReturnPending") || { Count: 0 }).Count;
        this.AssesmentPending = (aitem.find(item => item.Category === "Assessment Pending") || { Count: 0 }).Count;
        this.Selected = (aitem.find(item => item.Category === "Selected") || { Count: 0 }).Count;
        this.Reject = (aitem.find(item => item.Category === "Rejected") || { Count: 0 }).Count;

        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }



  GetFreelancerDetailsByID() {

    $("#LoadingImagePopup1").show();
    this.GetSourceList();
    this.GetInterestList();
    this.GetRestrictionList();
    this.GetLanguageList();
    this.GetCountryList();
    this.GetCategoryList();

    //$('#ULTabul').show();
    $('#btnPopupartDetails').show();
    this.Disablepopupfields();
    $('#popupbody').css('height', (GlobalConstants.size.height - 20));
    ApiMethod.getMethod(this.modelItem.getFreelancerbyIdAPI + "/" + localStorage.aEID + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      Response => {
        var aitems = Response.aListbysp;
        //console.log(Response.aListbysp);
        var aTestfilelist = Response.aTestfile;
        //this.CategoryList = Response.acategory;
        this.TestCategoryList = Response.acategory;
        $("#tblTaskSer tbody").html("");
        let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
        if (aTestfilelist.length != 0) {
          var nRowL = "";
          for (var i = 0; i < aTestfilelist.length; i++) {
            nRowL += "<tr id='trsc_" + (i + 1).toString() + "'>";
            nRowL += "<td>" + (i + 1).toString() + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(aTestfilelist[i].Taskname) + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(aTestfilelist[i].ArticleNo) + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].ExpectedStartDate)) + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].DueDate)) + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].UploadDate)) + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate)) + "</td>";
            nRowL += "<td style='text-align: center'>"
            if (GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate) == '' && GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) != '') {

              //+ "<i class='bx bx-download' title='Download' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
              nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
              nRowL += "<i class='bx bx-download' title='Freelancer File' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnUploadedTestFile').trigger('click');></i>";
              nRowL += "<i class='bx bx-paper-plane' title='Assessment' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnAssessmentShow').trigger('click');></i>";

            }
            else if (GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) != '' && GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate) != '') {
              nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"

              nRowL += "<i class='bx bx-download' title='Freelancer File' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnUploadedTestFile').trigger('click');></i>";
              nRowL += "<i class='bx bx-info-circle' title='Assessment' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnAssessmentInfo').trigger('click');></i>";
            }
            else if (GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) == '') {
              nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
              if (!aTestfilelist[i].UploadDate) {
                nRowL += "<i class='bx bxs-trash' title='Delete Test' style='color: #f46a6a; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btndeleteconfig').trigger('click');></i>";
              }
            }

            + "</td>";
            nRowL += "</tr>";
          }
          $("#tblTaskSer tbody").append(nRowL);
        }

        this.vendorname = aitems[0].VendorName;
        this.DownloadFilepath = aitems[0].ProfilePath;
        $('#Txt_Name').val(aitems[0].VendorName);
        $('#Txt_EmailID').val(aitems[0].EmailID);
        $('#Txt_TeamID').val(aitems[0].MicrosoftTeamId);
        $('#Txt_AltEmailID').val(aitems[0].AlternateEmailID);
        $('#Txt_mobile').val(aitems[0].ContactNo);
        $('#Txt_address').val(aitems[0].Address);
        $('#Txt_pincode').val(aitems[0].ZIPPostCode);
        $("#ddlGender").val(aitems[0].Gender).change();
        $("#Txt_ResultStatus").val(aitems[0].ResultStatus);
        $("#Txt_ResultRemark").val(aitems[0].ResultRemarks);
        $("#Txt_Ratings").val(aitems[0].Rating);
        $('#Txt_DOB').val(GlobalConstants.SetValue_FormatDate(aitems[0].DOB));
        $('#Txt_information').val(aitems[0].Notes);
        if (aitems[0].ResultStatus != null) {
          $('#Txt_ResultStatus').attr('disabled', 'disabled');
          $('#Txt_ResultRemark').attr('disabled', 'disabled');
          $('#Txt_Ratings').attr('disabled', 'disabled');
          $('#testupdate').hide();
        }


        $('#ddlCountry').val(aitems[0].Country).change();
        if ($('#ddlCountry').val() != null) {
          this.GetState(aitems[0].StateProvince, aitems[0].City);
        }


        if (aitems[0].Image == null)
          $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
        else
          $('#imgProfile').attr('src', aitems[0].Image);

        //Source
        if (aitems[0].Source != null) {
          var data = aitems[0].Source.split(',');

        } else
          data = null;
        var selectedValues = new Array();
        try {
          for (var i = 0; i < data.length; i++) {
            selectedValues[i] = data[i];
          }
        } catch (e) {
        }

        $('#ddlSourceList').val(selectedValues).change();

        //Language
        if (aitems[0].Language != null) {
          data = aitems[0].Language.split(',');
        } else
          data = null;
        selectedValues = new Array();
        try {
          for (var i = 0; i < data.length; i++) {
            selectedValues[i] = data[i];
          }
        } catch (e) {
        }
        $('#ddlLanguageList').val(selectedValues).change();


        /* Interest*/
        if (aitems[0].VMInterest != null) {
          data = aitems[0].VMInterest.split(',');
        } else
          data = null;
        selectedValues = new Array();
        try {
          for (var i = 0; i < data.length; i++) {
            selectedValues[i] = data[i];
          }
        } catch (e) {
        }
        $('#ddlInterestList').val(selectedValues).change();
        //Restriction
        if (aitems[0].VMRestriction != null) {
          data = aitems[0].VMRestriction.split(',');
        } else
          data = null;
        selectedValues = new Array();
        try {
          for (var i = 0; i < data.length; i++) {
            selectedValues[i] = data[i];
          }
        } catch (e) {
        }
        $('#ddlRestrictionList').val(selectedValues).change();
        //Category List
        if (aitems[0].Category != null) {
          var data = aitems[0].Category.split(',');
        } else
          data = null;
        var selectedValues = new Array();
        try {
          for (var i = 0; i < data.length; i++) {
            selectedValues[i] = data[i];
          }
        } catch (e) {
        }
        $('#ddlCategory').val(selectedValues).change();

        //File check

        if (aitems[0].NTFileName == null) {
          $("#dtn_downloadpdf").attr("style", "display:none;");
          $("#TestResult").attr("style", "display:none;");
          $("#dtn_Correctiontestfile").attr("style", "display:none;");
          $("#dtn_uploadpdf").attr("style", "display:block;");

        } else {
          $("#dtn_uploadpdf").attr("style", "display:none;");
          $("#dtn_downloadpdf").attr("style", "display:block;");
        }

        if (aitems[0].UploadFileName == null) {

          $("#dtn_Correctiontestfile").hide();
          $("#TestResult").hide();
        } else {

          $("#dtn_Correctiontestfile").show();
          $("#TestResult").show();
        }
        this.freelancerApproveStatus = aitems[0].ApproveStatus;
        if (aitems[0].ApproveStatus == "NEW") {

          $("#grpAcceptDecline").attr("style", "display:block;");

        }
        else {
          $("#grpAcceptDecline").attr("style", "display:none;");

        }
        $("#LoadingImagePopup1").hide();

      }, error => {
        $("#LoadingImagePopup1").hide();
        ngswal("Failed !", error.message, "error");
      });

  }

  GetAssignmentPopup() {
    FreelancerlistComponent.testAssignFrom = "List";
    var data = localStorage.aEID.split('|');
    TestAssignmentComponent.AssignmentDetails(data[0], data[1]);

    $('#TestassignPopup').show();

  }
  testassignpopup() {
    if (this.freelancerApproveStatus != "NEW") {
      FreelancerlistComponent.testAssignFrom = "PopUp";
      var data = localStorage.aEID;
      TestAssignmentComponent.AssignmentDetails(data, $('#ddlTestCategory').val());

      $('#TestassignPopup').show();
    }
    else {
      ngswal("Failed !", "Please Approve/Decline the freelancer..!", "warning");
      return;
    }

  }
  GetAssessmentpopup() {
    FreelancerlistComponent.testAssignFrom = "List";
    TestAssessmentComponent.AssessmentDetails(localStorage.aEID);
    
    $('#Testassessmentpopup').show();
  }
  assessmentPopup() {
    FreelancerlistComponent.testAssignFrom = "PopUp";
    TestAssessmentComponent.AssessmentDetails(localStorage.aFEID);
    $('#Testassessmentpopup').show();

  }

  Disablepopupfields() {

    $('#txtFeedbackDesc').attr('disabled', 'disabled');
    $('#Txt_Name').attr('disabled', 'disabled');
    $('#Txt_EmailID').attr('disabled', 'disabled');
    $('#Txt_TeamID').attr('disabled', 'disabled');
    $('#Txt_AltEmailID').attr('disabled', 'disabled');
    $('#Txt_mobile').attr('disabled', 'disabled');
    $('#Txt_DOB').attr('disabled', 'disabled');
    $('#ddlGender').attr('disabled', 'disabled');
    $('#Txt_address').attr('disabled', 'disabled');
    $('#Txt_pincode').attr('disabled', 'disabled');
    $('#ddlCountry').attr('disabled', 'disabled');
    $('#ddlState').attr('disabled', 'disabled');
    $('#ddlCity').attr('disabled', 'disabled');
    $('#ddlSourceList').attr('disabled', 'disabled');
    $('#ddlLanguageList').attr('disabled', 'disabled');
    $('#ddlInterestList').attr('disabled', 'disabled');
    $('#ddlRestrictionList').attr('disabled', 'disabled');
    $('#ddlCategory').attr('disabled', 'disabled');
    $('#Txt_information').attr('disabled', 'disabled');
    $('#fileupload').hide();
    $('#imageUploadForm').hide();
    $('#footer').hide();
  }

  hide() {
    $('#btnPopupartDetails').hide();
    $('#btnTestDetails').hide();
    $('#btnPopuptestDetails').hide();
    $('#btnPopupassessment').hide();
    $('#btnPopuptestDetails').hide();
    $('#modalPopupInvite').hide();
  }


  // Confirmation for Test allocation Upload
  confirmation() {
    if ($('#doc_testfile').val() == "") {
      $('#doc_testfile').val("");
      ngswal("Failed !", "Please upload File..!", "warning");
      return;
    }
    ngswal({
      title: "File Upload Confirmation",
      text: "Are you sure Submit test file?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#doc_testfile').trigger("click");
        } else {
          $('#doc_testfile').val("");
          return false;
        }
      });
  };
  //testfileupload
  testfileupload() {
    $("#LoadingImageReopen").show();
    var filedetails = {
      ID: localStorage.aEID,
      fileName: this.file.name,
      fileSize: this.file.size,
      fileAsBase64: this.fileBase64,
      Description: $("#Txt_Description").val()
    }
    ApiMethod.postMethod(this.modelItem.FreelancertestallocationAPI, filedetails).subscribe(
      response => {
        $("#LoadingImageReopen").hide();
        $('#doc_AllocationTestfile').val("");
        if (response.status == "Failed") {
          $("#LoadingImageReopen").hide();
          ngswal({
            position: "top-end",
            type: "error",
            title: "Error!",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });

        } else {
          ngswal({
            position: "top-end",
            type: "success",
            title: "Uploaded!",
            text: response.message,
            showConfirmButton: true,

          });

        }
        this.GetFreelancerDetailsByID()
        $("#LoadingImageReopen").hide();
      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.error.Message, "error");
      });
    /*return this.status;*/
  }

  //Update Test Result
  UpdateTestFileData(): void {
    if ($('#Txt_ResultStatus').val().trim() == '') {
      ngswal("Warning !", "Enter Result Status!", "warning");
    } else if ($('#Txt_Ratings').val().trim() == '') {
      ngswal("Warning !", "Enter Ratings!", "warning");
    }
    else {
      $("#LoadingImageReopen").show();

      const checkbox = document.getElementById('Notifymail') as HTMLInputElement;
      var notify = 0;
      if (checkbox.checked) {
        notify = 1;
      }
      else {
        notify = 0;
      }
      var details = {
        ID: localStorage.aEID,
        ResultStatus: $("#Txt_ResultStatus").val(),
        ResultRemark: $("#Txt_ResultRemark").val(),
        Ratings: $("#Txt_Ratings").val(),
        notifytoEmail: notify
      }

      ApiMethod.postMethod(this.modelItem.UpdateTestResultAPI, details).subscribe(
        response => {
          $("#LoadingImageReopen").hide();
          ngswal({
            position: "top-end",
            type: "success",
            title: " Updated Successfully!",
            text: response,
            showConfirmButton: true

          });
          this.GetFreelancerDetailsByID();
        }, error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImageReopen").hide();
        }
      );
    }
  }
  //test File download
  testfiledownload() {
    $("#LoadingImageReopen").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancertestfileAPI + "/" + localStorage.aEID);
    this.GetFreelancerDetailsByID()
    $("#LoadingImageReopen").hide();
  }
  //resume download
  Resumefiledownload() {
    $("#LoadingImageReopen").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancerResumefileAPI + "/" + localStorage.aEID);
    $("#LoadingImageReopen").hide();
  }
  // Correctiontestfile download
  Correctiontestfile() {
    $("#LoadingImage").show();
    var aEid = this.Freelancerid;
    ApiMethod.Downloadfile(this.modelItem.CorrectiontestfileAPI + "/" + localStorage.aEID);
    $("#LoadingImage").hide();
  }
  //Download Test File 
  downloadtestfileassign() {
    $("#LoadingImageReopen").show();
    ApiMethod.Downloadfile(this.modelItem.FreelancerTestDownload + localStorage.aFEID);
    $("#LoadingImageReopen").hide();
  }
  downloadUploadedTestFile() {
    $("#LoadingImageReopen").show();
    ApiMethod.Downloadfile(this.modelItem.getFreelancerUploadedTestFileDownload + localStorage.aFEID);
    $("#LoadingImageReopen").hide();
  }

  //Test Assignment For freelancer
  // Update test assign
  TestAssign() {
    if ($('#doc_testfile').val() == "") {
      $('#doc_testfile').val("");
      ngswal("Failed !", "Please upload Test File..!", "warning");
      return false;
    }
    $("#LoadingImageReopen").show();
    var details = {
      PublisherId: localStorage.aPubID,
      ID: localStorage.aEID,
      TaskId: $("#ddlcategory").val(),
      ArticleID: $("#ddlArticle").val(),
      ArticleTitle: $("#Txt_articleTitle").val(),
      ExpectedStartDate: $("#Txt_FromDate").val(),
      DueDate: $("#Txt_ToDate").val(),
      Notes: $("#TXT_Remarks").val(),
      PackageName: $("#doc_AllocationTestfile").val(),
      fileName: this.file.name,
      fileSize: this.file.size,
      fileAsBase64: this.fileBase64,

    }

    ApiMethod.postMethod(this.modelItem.FreelancerTestAllocation, details).subscribe(
      response => {
        $("#LoadingImageReopen").hide();
        if (response.status) {
          ngswal({
            position: "top-end",
            type: "success",
            title: " Updated Successfully!",
            text: response.message,
            showConfirmButton: true
          });
        }
        else {
          ngswal({
            position: "top-end",
            type: "warning",
            title: " Failed !",
            text: response.message,
            showConfirmButton: true

          });
        }

        this.GetFreelancerDetailsByID();
      }, error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImageReopen").hide();
      }
    );
  }

  // Confirmation Delete TestAssign
  DeleteTestTransConfirmation() {
    var rowCount = $('#tblTaskSer tbody tr').length;
    if (rowCount <= 1) {
      ngswal("Warning !", "Delete Trans not allowed  !", "warning");
      return false;
    }
    ngswal({
      title: "Delete Confirmation",
      text: "Are you sure Delete TestAssign details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btndeleteconfig').trigger("click");
        } else {
          return false;
        }
      });
  };

  Deletefileassign() {

    $("#LoadingImageReopen").show();
    ApiMethod.getMethod(this.modelItem.FreelancerTestFileDeletebyID + "/" + localStorage.aFEID).subscribe(
      Response => {

        if (Response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: Response.message,
            showConfirmButton: true,
          });
        } else {
          ngswal({
            position: 'top-end',
            type: "warning",
            title: "Failed !",
            text: Response.message,
            showConfirmButton: true,
          });
        }

        $("#LoadingImageReopen").hide();
      }, error => {
        $("#LoadingImageReopen").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }

  //testAssigned cleardata 
  ClearData(): void {
    $("#ddlcategory").val(0).change();
    $("#ddlArticle").val(0).change();
    $("#Txt_articleTitle").val('');
    $("#Txt_FromDate").val('');
    $("#Txt_ToDate").val('');
    $("#TXT_Remarks").val('');

  }
  onuploadSelected(fileInput: any) {
    var allocate = $('#doc_testfile').val().split('.').pop().toLowerCase();
    var ext = $('#doc_testfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
      $('#doc_testfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else if (fileInput.target.files[0].size > 52428800) {
      $('#doc_testfile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }

  updateRightSideAssesmentTable(aitemsList) {
    $("#tbltestassesment tbody").html("");
    let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
    if (aitemsList.length != 0) {
      aitemsList.forEach((item, index) => {
        let nRowL = "<tr id='trsc_" + (index + 1) + "'>";
        nRowL += "<td>" + (index + 1) + "</td>";
        nRowL += "<td>" + GlobalConstants.isNullCheck(item.TaskName) + "</td>";
        nRowL += "<td>" + GlobalConstants.isNullCheck(item.ArticleNo) + "</td>";
        nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(item.Results)) + "</td>";
        nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(item.Score)) + "</td>";
        nRowL += "<td>" + GlobalConstants.isNullCheck(item.Remarks) + "</td>";
        nRowL += "<td style='text-align: center'>"
        "<i class='bx bx-info-circle' title='Info' data-col='" + "' onclick=localStorage.aEID='" + "';" + "localStorage.clicktype='ipopup';" +
          + "</td>";
        nRowL += "</tr>";
        $("#tbltestassesment tbody").append(nRowL);
      });
    }
  }
  HideAssignment() {
    this.showpopupTestassign = false;
  }

  static Testassignhide() {
    if (FreelancerlistComponent.testAssignFrom == "List") {
      location.reload();
    }
    else {
      $("#LoadingImagePopup1").show();
      ApiMethod.getMethod(FreelancerlistComponent.modelItemSt.getFreelancerbyIdAPI + "/" + localStorage.aEID + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
        Response => {

          var aTestfilelist = Response.aTestfile;

          $("#tblTaskSer tbody").html("");
          let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
          if (aTestfilelist.length != 0) {
            var nRowL = "";
            for (var i = 0; i < aTestfilelist.length; i++) {
              nRowL += "<tr id='trsc_" + (i + 1).toString() + "'>";
              nRowL += "<td>" + (i + 1).toString() + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(aTestfilelist[i].Taskname) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(aTestfilelist[i].ArticleNo) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].ExpectedStartDate)) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].DueDate)) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].UploadDate)) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate)) + "</td>";
              nRowL += "<td style='text-align: center'>"
              if (GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate) == '' && GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) != '') {

                //+ "<i class='bx bx-download' title='Download' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
                nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
                nRowL += "<i class='bx bx-download' title='Freelancer File' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnUploadedTestFile').trigger('click');></i>";
                nRowL += "<i class='bx bx-paper-plane' title='Assessment' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnAssessmentShow').trigger('click');></i>";

              }
              else if (GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) != '' && GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate) != '') {
                nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"

                nRowL += "<i class='bx bx-download' title='Freelancer File' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnUploadedTestFile').trigger('click');></i>";
                nRowL += "<i class='bx bx-paper-plane' title='Assessment' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnAssessmentShow').trigger('click');></i>";
              }
              else if (GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) == '') {
                nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
                if (!aTestfilelist[i].UploadDate) {
                  nRowL += "<i class='bx bxs-trash' title='Delete Test' style='color: #f46a6a; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btndeleteconfig').trigger('click');></i>";
                }
              }

              + "</td>";
              nRowL += "</tr>";
            }
            $("#tblTaskSer tbody").append(nRowL);
          }

          $("#LoadingImagePopup1").hide();

        }, error => {
          $("#LoadingImagePopup1").hide();
          ngswal("Failed !", error.message, "error");
        });
    }


    $('#TestassignPopup').hide();
  }


  HideAssesment() {
    this.showpopupTestassessment = false;
  }
  testassesmentpopup() {
    $("#testassesmentform").show();
    this.showpopupTestassessment = true;
  }
  static Testassessmenthide() {
    if (FreelancerlistComponent.testAssignFrom == "List") {
      location.reload();
     
    }
    else {
      $("#LoadingImagePopup1").show();
      ApiMethod.getMethod(FreelancerlistComponent.modelItemSt.getFreelancerbyIdAPI + "/" + localStorage.aEID + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
        Response => {
         
          var aTestfilelist = Response.aTestfile;
       
          $("#tblTaskSer tbody").html("");
          let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
          if (aTestfilelist.length != 0) {
            var nRowL = "";
            for (var i = 0; i < aTestfilelist.length; i++) {
              nRowL += "<tr id='trsc_" + (i + 1).toString() + "'>";
              nRowL += "<td>" + (i + 1).toString() + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(aTestfilelist[i].Taskname) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(aTestfilelist[i].ArticleNo) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].ExpectedStartDate)) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].DueDate)) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].UploadDate)) + "</td>";
              nRowL += "<td>" + GlobalConstants.isNullCheck(GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate)) + "</td>";
              nRowL += "<td style='text-align: center'>"
              if (GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate) == '' && GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) != '') {

                //+ "<i class='bx bx-download' title='Download' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
                nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
                nRowL += "<i class='bx bx-download' title='Freelancer File' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnUploadedTestFile').trigger('click');></i>";
                nRowL += "<i class='bx bx-paper-plane' title='Assessment' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnAssessmentShow').trigger('click');></i>";

              }
              else if (GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) != '' && GlobalConstants.FormatDate(aTestfilelist[i].AssessmentDate) != '') {
                nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"

                nRowL += "<i class='bx bx-download' title='Freelancer File' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnUploadedTestFile').trigger('click');></i>";
                nRowL += "<i class='bx bx-paper-plane' title='Assessment' style='color: blue; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btnAssessmentShow').trigger('click');></i>";
              }
              else if (GlobalConstants.FormatDate(aTestfilelist[i].UploadDate) == '') {
                nRowL += "<i class='bx bx-download' title='Test File' " + styleEdit + " onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#Showfreelists').trigger('click');></i>&nbsp;"
                if (!aTestfilelist[i].UploadDate) {
                  nRowL += "<i class='bx bxs-trash' title='Delete Test' style='color: #f46a6a; font-size: 20px; cursor: pointer;' onclick=localStorage.aFEID='" + aTestfilelist[i].Id + "';$('#btndeleteconfig').trigger('click');></i>";
                }
              }

              + "</td>";
              nRowL += "</tr>";
            }
            $("#tblTaskSer tbody").append(nRowL);
          }

          $("#LoadingImagePopup1").hide();

        }, error => {
          $("#LoadingImagePopup1").hide();
          ngswal("Failed !", error.message, "error");
        });
    }
    $('#Testassessmentpopup').hide();

  }
  Testassessmenthide() {
    $('#Testassessmentpopup').hide();
  }
  AddUpdateDeclineReason(): void {
    if ($('#txt_declineReason').val().trim() == '') {
      ngswal("Warning !", "Enter Reason for Decline  !", "warning");
    }
    $("#LoadingImage").show();
    var dataParam = {
      FreelancerId: localStorage.aEID,
      ID: localStorage.aEID,
      DeclineReason: $('#txt_declineReason').val(),
      UpdatedBy: localStorage.aLoginID,
      Approve: true,
      Decline: false

    }
    ApiMethod.postMethod(this.modelItem.DeclineFreelancerbyID, dataParam).subscribe(
      result => {
        if (result.status) {
          this.showModal = false;
          ngswal("Success !", result.message, "success");
          this.hide();
        } else {
          ngswal("Failed !", result.message, "warning");
        }
        this.GetFreelancerData();
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }
  Decline() {
    $('#txt_declineReason').jqte();
    this.showModal = true;
  }
  hideDecline() {
    this.showModal = false;
  }
  UpdateAccept() {
    $("#LoadingImage").show();
    var dataParam = {
      FreelancerId: localStorage.aEID,
      UpdatedBy: localStorage.aLoginID,
      Approve: true,
    }
    ApiMethod.postMethod(this.modelItem.ApproveFreelancerbyID, dataParam).subscribe(
      result => {
        if (result.status) {
          this.showModal = false;
          ngswal("Success !", result.message, "success");
          //this.GetFreelancerDetailsByID();
          //this.GetFreelancerData();
          //this.GetFreelancerAssignmentPending();
        } else {
          ngswal("Failed !", result.message, "warning");
        }
        this.GetFreelancerData();
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  assessmentInfo() {
    $("#LoadingImageMeta").show();
    ApiMethod.getMethod(this.modelItem.FreelancerAssessmentInfo + "/" + localStorage.aFEID).subscribe(
      Response => {
        var aitems = Response.aAssessmentChecklist;
        var aSummary = Response.aAssessmentSummary;
        var aDtls = Response.aEvaluationDtls;
        $("#text_Result").html(GlobalConstants.isNullCheck(aDtls[0].ResultStatus));
        $("#text_Score").html(GlobalConstants.isNullCheck(aDtls[0].Rating));
        $("#text_Remarks").html(GlobalConstants.isNullCheck(aDtls[0].ResultRemarks));
        $("#tbl_checklist tbody").empty();
        if (aitems.length !== 0) {
          var nRowR = "";
          for (let i = 0; i < aitems.length; i++) {
            
            nRowR += "<tr id='tr" + (i + 1).toString() + "'>";
            nRowR += "<td>" + (i + 1) + "</td>";
            nRowR += "<td>" + GlobalConstants.isNullCheck(aitems[i].Checklist) + "</td>";
            nRowR += "<td><div class='emoji-table'><div class='emoji-div'><div class='rating' data-rating-id='" + GlobalConstants.isNullCheck(aitems[i].FeedbackRating) + "' value='" + GlobalConstants.isNullCheck(aitems[i].FeedbackRating) + "'></div></div></div></td>";
            nRowR += "</tr>";
          }
          $("#tbl_checklist tbody").append(nRowR);


          $(".emoji-table .rating").each(function (ind) {
           
            $(this).emoji({
              value: $(this).attr("data-rating-id"),
              emojis: ['&#x2B50;', '&#x2B50;', '&#x2B50;', '&#x2B50;', '&#x2B50;'],
            });
          });
        }
        $("#tblassessmentsummary tbody").empty();
        if (aSummary.length !== 0) {
          var nRowR = "";
          for (let i = 0; i < aSummary.length; i++) {

            nRowR += "<tr id='tr" + (i + 1).toString() + "'>";
            nRowR += "<td>" + (i + 1) + "</td>";
            nRowR += "<td>" + GlobalConstants.isNullCheck(aSummary[i].Issues) + "</td>";
            nRowR += "<td>" + GlobalConstants.isNullCheck(aSummary[i].Examples) + "</td>";
            nRowR += "<td>" + GlobalConstants.isNullCheck(aSummary[i].PageNo) + "</td>";
            nRowR += "</tr>";
          }
          $("#tblassessmentsummary tbody").append(nRowR);


          
        }
       
        $("#AssessmentInfoPopup").show();
        $("#LoadingImageMeta").hide();

      }, error => {
        $("#LoadingImageMeta").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  AssessmentInfoHide() {
    $("#AssessmentInfoPopup").hide();
  }
}

